<template>
  <div style="margin-top: 50px">

    <div v-if="response && informacoesPrincipais" class="p-4 my-8" style="background-color: #f0f0f0;">
      <h2 class="text-xl font-semibold mb-4">Resultados encontrados</h2>
      <div class="grid gap-5 grid-cols-2 md:grid-cols-[repeat(auto-fit,minmax(150px,1fr))]">
        <div
          v-for="(informacao, index) in informacoesPrincipais"
          :key="index"
          class="border-l border-gray-300 px-2 first:border-black lg:first:border-transparent"
        >
          <h3 class="font-bold text-gray-400 text-sm">
            {{ informacao.label }}
          </h3>
          <p class="text-base numero-processo font-semibold">
            {{ informacao.value }}
          </p>
        </div>
      </div>
    </div>

    <nav class="response-nav">
      <div
        class="flex text-gray-600 my-auto p-1 gap-2 bg-gray-200 rounded-lg items-center justify-center"
      >
        <input
          type="radio"
          id="lista"
          v-model="responseType"
          name="response-api"
          value="lista"
          class="hidden"
          checked
        />
        <label
          class="flex text-gray-600 gap-1 text-sm items-center py-1 pl-1 pr-2 m-0 cursor-pointer hover:bg-gray-100 rounded-md w-full label-2"
          for="lista"
        >
          <svg class="svg-icon -x24 svg-list">
            <use xlink:href="/assets/svg/user/icons.svg#svg-list"></use>
          </svg>
          Lista
        </label>

        <input
          type="radio"
          id="json"
          v-model="responseType"
          name="response-api"
          value="json"
          class="hidden"
        />
        <label
          class="flex gap-1 text-sm items-center py-1 pl-1 pr-2 m-0 cursor-pointer hover:bg-gray-100 rounded-md w-full label-1"
          for="json"
        >
          <svg class="svg-icon -x24 svg-code">
            <use xlink:href="/assets/svg/user/icons.svg#svg-code"></use>
          </svg>
          JSON
        </label>
      </div>

      <button
        class="relative flex items-center justify-center whitespace-nowrap rounded-xl font-medium text-sm text-brand-blue-900 bg-gray-100 px-4 py-3 hover:bg-blue-100"
        @click="downloadResponse"
        id="btn-download-playground"
        :disabled="$wait.is('dowloading')"
      >
        <svg
          v-if="$wait.is('dowloading')"
          class="animate-spin -ml-1 mr-3 h-5 w-5 text-gray-500 absolute"
          xmlns="http://www.w3.org/2000/svg"
          fill="none"
          viewBox="0 0 24 24"
        >
          <circle
            class="opacity-25"
            cx="12"
            cy="12"
            r="10"
            stroke="currentColor"
            stroke-width="4"
          ></circle>
          <path
            class="opacity-75"
            fill="currentColor"
            d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
          ></path>
        </svg>
        <span :class="{ 'opacity-0': $wait.is('dowloading') }"
        >Exportar {{ type }}</span
        >
      </button>
    </nav>

    <div v-if="responseType === 'lista'" class="relative">
      <table class="w-full overflow-x-scroll block rounded-md pr-8 mt-8">
        <thead class="sticky top-0 text-left rounded-md">
        <tr class="">
          <th class="md:sticky min-w-[32px] bg-white left-0"></th>
          <template v-for="coluna in colunasTabela">
            <th
              v-if="coluna.isVisible"
              :key="coluna.key"
              :class="{
                  'md:sticky md:left-8 bg-white': coluna.key === stickyItem,
                  'whitespace-nowrap': coluna.key !== 'assunto',
                }"
              class="px-4 py-3 font-bold text-gray-400 text-xs last:rounded-r-md first:rounded-l-md uppercase"
            >
              {{ coluna.label }}
            </th>
          </template>
        </tr>
        </thead>
        <tbody
          v-if="response?.length"
          class="bg-white divide-y divide-gray-200"
        >
        <template v-for="(processo, index) in response">
          <tr
            :key="logIds[0] + index"
            class="group hover:divide-gray-200 cursor-pointer"
            :class="{
                '!border-t-transparent':
                  (typeof indexProcessoExpandido === 'number' &&
                    indexProcessoExpandido + 1 === index) ||
                  indexProcessoExpandido === index,
              }"
            @click="toggleProcessoExpandido(index)"
          >
            <td
              class="md:sticky md:left-0 min-w-[32px] text-gray-400 text-sm text-center"
              :class="{
                  'bg-gray-200 rounded-tl-lg': indexProcessoExpandido === index,
                  'bg-white': indexProcessoExpandido !== index,
                }"
            >
              {{ index + 1 }}
            </td>
            <template v-for="coluna in colunasTabela">
              <td
                v-if="coluna.isVisible"
                :key="coluna.key"
                :class="{
                    'md:sticky md:left-8 whitespace-nowrap scroll-animation numero-processo font-semibold':
                      coluna.key === stickyItem,
                    'text-gray-600 whitespace-nowrap':
                      coluna.key !== stickyItem,
                    'max-w-xs text-ellipsis overflow-hidden': deveTruncarColuna(coluna.key),
                    'whitespace-nowrap': coluna.key !== 'assunto',
                    'bg-gray-200 last:rounded-tr-lg':
                      indexProcessoExpandido === index,
                    'bg-white': indexProcessoExpandido !== index,
                    'group-hover:bg-gray-100':
                      coluna.key !== stickyItem &&
                      indexProcessoExpandido !== index,
                  }"
                class="py-5 px-4 text-sm"
              >
                {{ processo[coluna.key] }}
                <div
                  class="text-xs font-normal text-gray-400 max-w-xs overflow-ellipsis overflow-hidden"
                  v-if="
                      coluna.key === 'numeroCnj' &&
                      processo.poloAtivo &&
                      processo.poloAtivo !== '-' &&
                      processo.poloPassivo !== '-'
                    "
                >
                  {{ processo.poloAtivo }} x
                  {{ processo.poloPassivo }}
                </div>
              </td>
            </template>
          </tr>
          <tr
            v-if="indexProcessoExpandido === index"
            :key="index"
            class="!border-t-0"
          >
            <td
              :class="{
                  'bg-gray-100 rounded-b-lg': indexProcessoExpandido === index,
                }"
              :colspan="colunasTabela.filter((c) => c.isVisible).length + 1"
            >
              <div class="px-12 pt-4 pb-8 flex flex-col gap-4">
                <template v-for="coluna in colunasTabela">
                  <div class="flex flex-col gap-1" :key="coluna.key">
                    <div class="text-sm font-semibold text-gray-600">
                      {{ coluna.label }}
                    </div>
                    <div class="text-sm text-gray-600" v-html="formatNewLines(processo[coluna.key])">
                    </div>
                  </div>
                </template>
              </div>
            </td>
          </tr>
        </template>
        </tbody>
        <tbody v-else>
        <tr>
          <td colspan="9" style="text-align: center">
            Nenhum processo foi encontrado.
          </td>
        </tr>
        </tbody>
      </table>
      <div
        class="absolute right-0 top-0 h-full w-12 bg-gradient-to-l z-10 pointer-events-none from-white"
      ></div>
    </div>

    <div v-else>
      <pre id="response-api"
           ref="responseCard"
           class="card">{{ response }}</pre>
    </div>

    <div class="div-pagination" v-if="!isDisable">
      <Btn
        class="info upper md"
        @click="carregarMais"
        :loading="$wait.is(`pagination_${this.identificador}`)"
        :disabled="$wait.is(`pagination_${this.identificador}`)"
      >
        Carregar mais
      </Btn>
    </div>
  </div>
</template>

<script>
import playgroundApi from "../../../api/playground";
import Vue from "vue";
import Table from "../../../../user/js/components/Table/Table.vue";
import {IdentificadorServico} from "../../../utils/identificadores-servicos-api";

export default {
  name: "Response",
  components: {Table},
  props: {
    responseApi: {
      type: Object,
      default: () => ({}),
      required: true,
    },
    logIds: {
      type: Array,
      required: true,
    },
    identificador: {
      type: String,
      required: true,
    },
    listaFormatada: {
      type: Array,
      required: true,
    },
    informacoesPrincipais: {
      type: [Array, null],
      default: () => [],
    },
    colunas: {
      type: Array,
    },
    tiposDownload: {
      type: Array,
      default: () => ['json', 'lista']
    }
  },
  watch: {
    responseApi(_) {
      if (_ && this.responseType === "json") {
        this.$refs.responseCard.scrollTop = 0;
      }
    },
    responseType(next) {
      this.tipoDownload = this.tiposDownload.includes(next) ? next : 'json';
    }
  },
  mounted() {
    this.indexProcessoExpandido = this.listaFormatada?.length === 1 ? 0 : null;
    this.tipoDownload = this.tiposDownload.includes('lista') ? 'lista' : 'json';
  },
  data() {
    return {
      responseType: "lista",
      tipoDownload: "lista",
      indexProcessoExpandido: null,
      colunasTabela: this.colunas || [
        {key: "numeroCnj", label: "Processo", isVisible: true},
        {
          key: "dataDistribuicao",
          label: "Data de distribuição",
          isVisible: true,
        },
        {key: "fonteSigla", label: "Tribunal", isVisible: true},
        {key: "fonteSistema", label: "Sistema", isVisible: false},
        {key: "grauFormatado", label: "Instância", isVisible: true},
        {key: "assunto", label: "Assunto", isVisible: true},
        {key: "classe", label: "Classe", isVisible: false},
        {key: "area", label: "Área", isVisible: false},
        {
          key: "orgaoJulgador",
          label: "Órgão julgador",
          isVisible: false,
        },
        {
          key: "valorFormatado",
          label: "Valor da causa",
          isVisible: true,
        },
        {key: "arquivado", label: "Arquivado", isVisible: false},
        {
          key: "dataUltimaMovimentacao",
          label: "Data última movimentação",
          isVisible: false,
        },
        {key: "poloAtivo", label: "Polo ativo", isVisible: false},
        {key: "poloPassivo", label: "Polo passivo", isVisible: false},
        {key: "envolvidos", label: "Outras partes", isVisible: false},
      ],
    };
  },
  computed: {
    response() {
      if (this.responseType === "json") {
        return this.responseApi;
      }
      return this.listaFormatada;
    },
    type() {
      return this.tipoDownload === "lista" ? "EXCEL" : "JSON";
    },
    isDisable() {
      return !this.responseApi.hasOwnProperty('links') || this.responseApi.links.next === null;
    },
    stickyItem() {
      if (this.identificador === IdentificadorServico.CAPA_PROCESSO) {
        return 'grauFormatado'
      } else if (this.identificador === IdentificadorServico.PROCESSO_MOVIMENTACOES) {
        return 'conteudo'
      } else if (
        [IdentificadorServico.ATUALIZACAO_PROCESSO_RESUMO_IA, IdentificadorServico.STATUS_RESUMO_INTELIGENTE]
          .includes(this.identificador)
      ) {
        return 'status'
      } else if (this.identificador === IdentificadorServico.PROCESSO_RESUMO_IA) {
        return 'conteudo'
      } else {
        return 'numeroCnj'
      }
    },
    isTipoDownloadLista() {
      return this.tipoDownload === "lista";
    }
  },
  methods: {
    formatNewLines(value) {
      if (typeof value === 'string') {
        return value.replace(/\n/g, '<br>');
      }
      return value;
    },
    carregarMais() {
      let id = this.identificador.toLowerCase().replace('_', '-');
      this.$emit(`carregar-mais-${id}`);
    },
    deveTruncarColuna(key) {
      return ['assunto', 'conteudo'].includes(key?.toLowerCase());
    },
    downloadResponse() {
      if (this.isTipoDownloadLista) {
        return this.downloadLista();
      }

      let url =
        "data:application/json;charset=utf-8," +
        encodeURIComponent(JSON.stringify(this.responseApi));
      this.download(url);
    },
    downloadLista() {
      this.$wait.start("dowloading");

      let params = {
        query: {
          ids: this.logIds,
          identificador_servico: this.identificador,
        }
      }

      playgroundApi["DOWNLOAD_EXCEL"](params)
        .then((response) => {
          let metadata = response.headers.get("content-disposition");

          if (!metadata) {
            this.showMessage("error", "Não foi possível baixar o arquivo!");
            return;
          }

          let blob = new Blob([response.data], {
            type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
          });

          let url = window.URL.createObjectURL(blob);
          this.download(url);
        })
        .catch((_) => {
          this.showMessage("error", "Não foi possível baixar o arquivo!");
        })
        .finally(() => {
          this.$wait.end("dowloading");
        });
    },
    download(url) {
      let a = document.createElement("a");
      a.href = url;
      a.download = this.identificador.toLowerCase() + (this.isTipoDownloadLista ? '' : '.json');
      document.body.appendChild(a);
      a.click();
      a.remove();
    },
    showMessage(type, message) {
      let options = {
        position: "bottom-center",
        duration: 3000,
        className: ["c-toast", "u--no-print"],
        containerClass: ["c-toast_container", "u--no-print"],
        closeOnSwipe: false,
      };

      Vue.toasted.error(message, {
        ...options,
        className: [...options.className, "v--negative"],
      });
    },
    toggleProcessoExpandido(index) {
      if (this.indexProcessoExpandido === index) {
        this.indexProcessoExpandido = null;
      } else {
        this.indexProcessoExpandido = index;
      }
    },
  },
};
</script>

<style scoped lang="stylus">
#response-api
  height 520px
  overflow auto
  color black
  margin-top 0

.truncate {
  height: 50px;
  overflow: hidden;
  text-overflow: ellipsis;
}

.btn
  background-color #F3F4F6
  color black
  border 0

input:checked + label
  background-color white

.response-nav
  display flex
  justify-content space-between
  padding-bottom 0.5rem

.div-pagination
  display flex
  justify-content center
</style>
